import { createContext, useContext, useState } from "react";

const MiniPlayerContext = createContext({ mini: null, openMini: () => {}, closeMini: () => {} });

export const MiniPlayerProvider = ({ children }) => {
  const [mini, setMini] = useState(null);
  return (
    <MiniPlayerContext.Provider value={{ mini, openMini: setMini, closeMini: () => setMini(null) }}>
      {children}
    </MiniPlayerContext.Provider>
  );
};

export const useMiniPlayer = () => useContext(MiniPlayerContext);
